import mixpanel from "common/mixpanel";
import pageData from "common/page-data";

const mixpanelService = {
  track(name, attributes = {}, callback) {
    // pageData.get returns a default {}
    const page = pageData.get("mixpanelData");
    const data = { ...attributes, ...page };
    return mixpanel.track(name, data, callback);
  },
  trackClick(name, attributes, callback) {
    return () => mixpanelService.track(name, attributes, callback);
  },
  trackLink(query, eventName, properties) {
    return mixpanel.track_links(query, eventName, properties);
  }
};

export default mixpanelService;
